/* eslint-disable no-prototype-builtins */
import axios from 'axios'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { positionChangeWidthSm, swipelyticsTurquoise } from '../../../../helpers/variableDefaults'
import { standardButton } from '../../../../helpers/buttons'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { standardErrorContainer } from '../../../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../../../helpers/typographies'
import { Input } from '../../../../helpers/globalHelpers'
import { modifyDatingProfileInDatabase } from '../../../../helpers/modifyInDatabase'
import { titleAndAdvisoryJSX, saveAndCancelButtonsJSX } from '../../../../helpers/commonJSX'

export const editAboutMeJSX = (
  isDemo,
  user, setUser,
  datingProfile, setDatingProfile,
  previousDatingProfile, setPreviousDatingProfile,
  newAboutMe, setNewAboutMe,
  openAboutMeSelectModal, setOpenAboutMeSelectModal,
  customAboutMeSelected, setCustomAboutMeSelected,
  openMediaItemSelectModal, openPromptSelectModal, openHobbySelectModal,
  loading, setLoading,
  saveSuccessful, setSaveSuccessful,
  errors, setErrors,
  resetLoadingAndErrors, resetSaveSuccessful,
  width
) => {

  const tapDisabled = () => {
    return (
      openPromptSelectModal 
      || openAboutMeSelectModal 
      || openHobbySelectModal
      || loading.loading
      || loading.mediaItems
      || loading.aboutMe
      || loading.prompts
      || loading.hobbies
      || loading.selectMediaItem
      || loading.selectAboutMe
      || loading.selectPrompt
      || loading.selectHobby
    )
  }

  const showSaveAndCancelButtons = () => {
    // console.log('mediaItem.url ->', Object.keys(mediaItem).length > 0 ? mediaItem.url : 'No Url')
    // console.log('previousURL ->', previousURL)
    // console.log('mediaItem.url === previousURL ->', mediaItem.url === previousURL)
    return !(
      Object.keys(datingProfile).length > 0
      && 'bio' in datingProfile
      && 'aboutMe' in datingProfile.bio
      && 'aboutMe' in previousDatingProfile.bio
      && datingProfile.bio.aboutMe === previousDatingProfile.bio.aboutMe
    )
  }

  const handleSelectItem = (e, selectedIndex) => {
    console.log('handleSelectItem runs')
    e.preventDefault()
    if (
      !(tapDisabled())
    ) {
      resetLoadingAndErrors()
      resetSaveSuccessful()
      setNewAboutMe('aboutMe' in datingProfile.bio && datingProfile.bio.aboutMe.length > 0 ? datingProfile.bio.aboutMe : '')
      setOpenAboutMeSelectModal(true)
    }
  }

  const handleCancelPressed = () => {
    // console.log('handleCancelPressed runs')
    const resetBio = {
      ...datingProfile.bio,
      aboutMe: previousDatingProfile.bio.aboutMe,
    }
    setDatingProfile({ ...datingProfile, bio: { ...resetBio } })
    resetSaveSuccessful()
  }

  const handleSavePressed = async () => {
    console.log('handleSavePressed runs')

    const newBio = {
      ...previousDatingProfile.bio,
      aboutMe: datingProfile.bio.aboutMe,
    }

    if (isDemo) {

      const updatedDatingProfilesForUser = user.datingProfiles.map((userDatingProfile, userDatingProfileIndex) => {
        return (
          userDatingProfile._id !== datingProfile._id 
            ?
            userDatingProfile
            :
            { 
              ...userDatingProfile,
              bio: { ...newBio },
            }
        )
      })
      setUser({ 
        ...user, 
        datingProfiles: [ ...updatedDatingProfilesForUser ],
      })
      
      setPreviousDatingProfile({ 
        ...previousDatingProfile, 
        bio: { ...newBio }, 
      })

    } else {

      const objectToUpload = {
        bio: { ...newBio },
      }
      // console.log('objectToUpload ->', objectToUpload)

      await modifyDatingProfileInDatabase(`aboutMe`, datingProfile._id, objectToUpload, errors, setErrors, loading, setLoading)

      const updatedDatingProfilesForUser = user.datingProfiles.map((userDatingProfile, userDatingProfileIndex) => {
        return (
          userDatingProfile._id !== datingProfile._id 
            ?
            (userDatingProfile.type === 'hinge' || userDatingProfile.bio.aboutMe.length > 0)
              ?
              userDatingProfile
              :
              {
                ...userDatingProfile,
                bio: {
                  ...userDatingProfile.bio,
                  aboutMe: datingProfile.bio.aboutMe,
                },
              }
            :
            { 
              ...userDatingProfile,
              bio: { ...newBio },
            }
        )
      })

      // Add default about me to User if necessary
      const newUserBioObj = { ...user.bio }
      if (
        datingProfile.bio.aboutMe.length > 0
        && 'aboutMe' in user.bio
        && user.bio.aboutMe !== null
        && Array.isArray(user.bio.aboutMe)
        && user.bio.aboutMe.filter(aboutMeString => aboutMeString.length > 0).length < 3
        && (
          (
            user.bio.aboutMe.length === 0 
            || user.bio.aboutMe.filter(aboutMeString => aboutMeString.length > 0).length === 0
          )
          ||
          !(
            user.bio.aboutMe.includes(datingProfile.bio.aboutMe)
          )
        )
      ) {
        const filteredCurrentAboutMeArray = user.bio.aboutMe.filter(aboutMeString => aboutMeString.length > 0)
        const newAboutMeArray = [ ...filteredCurrentAboutMeArray, datingProfile.bio.aboutMe ]

        newUserBioObj.aboutMe = [ ...newAboutMeArray ]
      }

      setUser({ 
        ...user, 
        datingProfiles: [ ...updatedDatingProfilesForUser ],
        bio: { ...newUserBioObj },
      })

      setPreviousDatingProfile({ 
        ...previousDatingProfile, 
        bio: { ...newBio }, 
      })
      
    }
  }

  return (
    <Box
      sx={{
        py: 3, mt: 2,
        width: width < positionChangeWidthSm ? '100%' : '90%',
        maxWidth: '600px',
        backgroundColor: showSaveAndCancelButtons() ? 'lightgray' : 'whitesmoke',
        borderRadius: width < positionChangeWidthSm ? 0 : 3, boxShadow: width < positionChangeWidthSm ? 3 : 3,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Input type="text" autoFocus="autoFocus" />
        </Box>

        {/* Title and Advisory JSX */}
        {titleAndAdvisoryJSX(
          'About Me', 
          '*Tap to edit',
          0
        )}


        {/* About Me */}
        <Box
          onClick={(e) => handleSelectItem(e, 0)}
          disabled={tapDisabled()}
          sx={{
            my: 1,
            width: '100%',
            backgroundColor: 'white',
            borderRadius: 3, boxShadow: 3,
            cursor: tapDisabled() ? '' : 'pointer',
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
          }}
        >
          {'bio' in datingProfile && datingProfile.bio !== null && Object.keys(datingProfile.bio).length > 0 && 'aboutMe' in datingProfile.bio && datingProfile.bio.aboutMe.length > 0
            ?
            <Typography
              sx={{
                px: 2, py: 1.5,
                width: '100%',
              }}
            >
              {datingProfile.bio.aboutMe}
            </Typography>
            :
            <Box
              sx={{
                width: '100%',
                backgroundColor: 'gray',
                boxShadow: 3, 
                borderRadius: '5px', 
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
              }}
            >
              <AddIcon 
                color='primary'
                sx={{
                  my: 1,
                  // boxShadow: 3, 
                  borderRadius: '50%',
                  border: 2, 
                  borderColor: 'black',
                  backgroundColor: 'white',
                  width: '35px', height: '35px',
                }}
              />
            </Box>
          }
        </Box>


        {/* Save and Cancel Buttons */}
        {showSaveAndCancelButtons()
          && saveAndCancelButtonsJSX(
            loading.aboutMe,
            (!(showSaveAndCancelButtons()) || loading.aboutMe),
            handleCancelPressed,
            handleSavePressed,
            0,
            0,
            2,
            'warning',
            'primary'
          )
        }

        {/* Loading */}
        {loading.aboutMe &&
          advisoryTypography(`Uploading Changes...`, 'center')
        }

        {/* Error Message */}
        {errors.aboutMe &&
          standardErrorContainer(`There was an error uploading the changes. Check your Internet connection and try again.`)
        }

        {/* Save Successful */}
        {saveSuccessful.aboutMe &&
          saveSuccessfulTypography()
        }
      </Box>
    </Box>
  )
}